<template>
    <div class="text-sm text-slate-600 mb-2 block" :class="locale.value === 'ar' ? ' font-arabic ' : ''">{{
        $t(`register.${props.type}_title`) }}</div>
    <div @click="handleFileClick"
        :class="'w-full h-20 bg-slate-50 hover:cursor-pointer hover:bg-gray-200 transition duration-200 border  flex flex-col justify-center items-center py-1 rounded-lg relative' + (registerStore.registration[props.type].error.hasError ? 'border-red-500    ' : ' border-dashed  border-slate-200 border-2')">

        <transition name="fade" mode="out-in">
            <div v-if="showLoader"
                class="absolute inset-0 w-full h-full bg-black/20 flex justify-center items-center z-10 rounded-lg ">
                <div class="loader"></div>
            </div>
        </transition>

        <Galery_icon v-if="previews.length < 1 && !showLoader" />
        <div v-else class="w-full flex justify-evenly items-center h-full ">
            <div v-for="(photo, index) in previews" :key="index"
                class="h-full w-1/5 flex justify-center items-center  relative ">

                <PreviewCard :photo="photo" @remove-image="removeImage(index)" />

            </div>
        </div>
        <p v-if="registerStore.registration[props.type].error.hasError" class="text-sm text-red-500 mt-1"
            :class="locale === 'ar' ? 'font-arabic' : ''">
            {{ $t("register.errors." + registerStore.registration[props.type].error.message) }}
        </p>
        <p v-else-if="files.length < 1" class="text-xs font-medium text-slate-400 mt-1"
            :class="locale === 'ar' ? 'font-arabic' : ''">
            {{ $t("register.filePreview.upload") }}
        </p>
    </div>

    <input ref="filesRefInput" type="file" class="hidden" multiple accept="image/*"
        @change="handleFileChange($event)" />
</template>

<script setup>
import { useRegistrationStore } from '@/stores/registrationStore';
import { defineProps, ref, defineEmits } from 'vue';
import Galery_icon from './icons/galery_icon.vue';
import PreviewCard from './previewCard.vue';

import imageCompression from 'browser-image-compression';
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()

const emit = defineEmits(['maxFileReached']);


const registerStore = useRegistrationStore();

const filesRefInput = ref(null);
const files = ref([]);
const previews = ref([]);

const props = defineProps({
    type: {
        type: String,
        required: true
    },

}
)


const handleFileClick = () => {

    if (files.value.length < 3) { filesRefInput.value.click(); }

}


const showLoader = ref(false);


const handleFileChange = async (event) => {
    const inputfiles = Array.from(event.target.files);
    const remainingSlots = 3 - files.value.length;
    showLoader.value = true;


    if (remainingSlots <= 0) {
        event.target.value = "";
        return;
    }

    const acceptedFiles = [];
    const acceptedPreviews = [];


    for (const file of inputfiles.slice(0, remainingSlots)) {


        try {

            const options = {
                maxSizeMB: 0.5,
                maxWidthOrHeight: 1280,
                useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);
            console.log('compressedFile.size :>> ', compressedFile.size / 1024 / 1024);
            acceptedFiles.push(compressedFile);

            const preview = URL.createObjectURL(compressedFile);
            acceptedPreviews.push(preview);
        } catch (err) {
            console.error('Compression failed:', err);
        }
    }

    if (inputfiles.length > remainingSlots) {
        emit('maxFileReached');
    }

    if (acceptedFiles.length === 0) {
        event.target.value = "";
        return;
    }

    files.value.push(...acceptedFiles);
    registerStore.registration[props.type].files = files.value;

    previews.value.push(...acceptedPreviews);
    registerStore.registration[props.type].previews = previews.value;


    registerStore.registration[props.type].error.hasError = false;
    registerStore.registration[props.type].error.message = '';

    event.target.value = "";

    showLoader.value = false;
};




const removeImage = (index) => {


    console.log('index :>> ', index);
    files.value.splice(index, 1);
    previews.value.splice(index, 1);

}

</script>



<style scoped>
.loader {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>